import CancelButton from './CancelButton'
import BackButton from './BackButton'
import StartTraining from './startTraining'
import GenerateBilling from './GenerateBilling'
import Reconcile from './Reconcile'
import CloseButton from './CloseButton'
import PricingButton from './PricingButton'
import GenerateFundingButton from './GenerateFunding'
import { STATUS_CODE_TRAINIG } from '../../../config/configuration'

type TrainingActionButtonsProps = {
    trainingTrackGUID: string
    trainingTrackId: string
    currentStatusCode: number | null
    userRole: string
    me: any
    onSuccess?: () => void
    onCancelSuccess?: () => void
    showBtn?: boolean
}


export default function TrainingActionButtons({ trainingTrackGUID, trainingTrackId, currentStatusCode, userRole, me, onSuccess, onCancelSuccess, showBtn }: TrainingActionButtonsProps) {
    return (
        <div className="d-flex align-items-center gap-2 flex-wrap justify-content-end detail-view-actions">
            {showBtn && STATUS_CODE_TRAINIG.seatValidation !== currentStatusCode && (
                <PricingButton />
            )}
            {showBtn && STATUS_CODE_TRAINIG.seatValidation === currentStatusCode && (
                <GenerateFundingButton
                    trainingTrackGUID={trainingTrackGUID}
                    trainingTrackId={trainingTrackId}
                    currentStatusCode={currentStatusCode}
                    userRole={userRole}
                    me={me}
                    onSuccess={onSuccess}
                />
            )}
            {showBtn && STATUS_CODE_TRAINIG.seatValidation !== currentStatusCode && (
                <StartTraining />
            )}
            {showBtn && STATUS_CODE_TRAINIG.seatValidation !== currentStatusCode && (
                <GenerateBilling />
            )}
            {showBtn && STATUS_CODE_TRAINIG.seatValidation !== currentStatusCode && (
                <Reconcile />
            )}
            {showBtn && STATUS_CODE_TRAINIG.seatValidation !== currentStatusCode && (
                <CloseButton />
            )}
            {!showBtn && (
                <CancelButton
                    trainingTrackGUID={trainingTrackGUID}
                    trainingTrackId={trainingTrackId}
                    currentStatusCode={currentStatusCode}
                    userRole={userRole}
                    me={me}
                    onSuccess={onCancelSuccess}
                />
            )}
            <BackButton />
        </div>
    )
}
